import { useState } from 'react';

interface CurriculumItem {
  period: string;
  type?: string;
  details: string[];
}

const go1Curriculum: CurriculumItem[] = [
  {
    period: '1~2월',
    type: '선행',
    details: [
      '문학 전 갈래 필수 개념어 및 독해 원리',
      '독서 유기적 독해법 체화',
      '문법 뼈대가 되는 문법 용어 체화',
      '어휘 고성성어, 한자어, 유의어',
      '숙제 12문항/20분 모고 매일 숙제',
      '특강: 고1~고3 과정 문법 심화',
    ],
  },
  {
    period: '3~4월',
    details: [
      '수능+내신 국담 내신 프로그램, 모고 기출 훈련',
    ],
  },
  {
    period: '5~6월',
    details: [
      '수능+내신 국담 내신 프로그램, 모고 기출 훈련',
    ],
  },
  {
    period: '7~8월',
    type: '선행',
    details: [
      '고2 수준 모고 훈련',
      '고전시가 특강',
    ],
  },
  {
    period: '9~10월',
    details: [
      '수능+내신 국담 내신 프로그램, 모고 기출 훈련',
    ],
  },
  {
    period: '11~12월',
    details: [
      '수능+내신 국담 내신 프로그램, 모고 기출 훈련',
    ],
  },
];

const go2Curriculum: CurriculumItem[] = [
  {
    period: '1~2월',
    type: '선행',
    details: [
      '비문학 지문 분석 유기적 독해 훈련',
      '2학년 필수고전시가 분석',
      '2학년 필수현대 문학 분석',
      '미니모의고사 감각 훈련',
      '모고 기출 문학 특강',
    ],
  },
  {
    period: '3~4월',
    details: [
      '수능+내신 국담 내신 프로그램, 모고 기출 훈련',
    ],
  },
  {
    period: '5~6월',
    details: [
      '수능+내신 국담 내신 프로그램, 모고 기출 훈련',
    ],
  },
  {
    period: '7~8월',
    type: '선행',
    details: [
      '독서 영역별 고난도 지문 독해 훈련',
      '고전+현대 주제로 엮어 보는 문학 흐름',
      '미니 모의고사 감각 훈련',
      '현대문법특강',
    ],
  },
  {
    period: '9~10월',
    details: [
      '수능+내신 국담 내신 프로그램, 모고 기출 훈련',
    ],
  },
  {
    period: '11~12월',
    details: [
      '수능+내신 국담 내신 프로그램, 모고 기출 훈련',
    ],
  },
];

interface Go3CurriculumItem {
  period: string;
  type: string;
  details: string[];
}

const go3Curriculum: Go3CurriculumItem[] = [
  {
    period: '1~2월',
    type: '수능',
    details: [
      '수능 독서 패턴 영역별 훈련',
      '수능 문학 패턴 영역별 훈련',
      '매주 1회 시뮬레이션 실시 등급 추적',
      '숙제 하프 모의고사 매일 숙제',
    ],
  },
  {
    period: '3~4월',
    type: '수능+내신',
    details: [
      '수능+내신 국담 내신 프로그램, 수능특강 독서 및 문학',
    ],
  },
  {
    period: '5~6월',
    type: '수능+내신',
    details: [
      '수능+내신 국담 내신 프로그램, 수능특강 독 및 문학',
    ],
  },
  {
    period: '7~8월',
    type: '선행',
    details: [
      '독서 영역별 고난도 지문 3점 공략',
      '문학 영역별 고난도 지문 3점 공략',
      '숙제 화법 or 언매 매일 1회 숙제',
      '숙제 하프모의고사 아침 매일 숙제',
      'EBS 수능완성 해설',
    ],
  },
  {
    period: '9~10월',
    type: '수능',
    details: [
      '사설 하프 모의고사 훈련',
      '주 2회 실전 모의고사 아침 시뮬레이션 숙제',
      'EBS 연계 출제 예상 작품 선별 분석',
    ],
  },
];

const periodColors: Record<string, string> = {
  '1~2월': 'from-[#ff6b6b] to-[#ff8e8e]',
  '3~4월': 'from-[#4ecdc4] to-[#6eddd6]',
  '5~6월': 'from-[#ffd93d] to-[#ffe36d]',
  '7~8월': 'from-[#ff6b6b] to-[#ff8e8e]',
  '9~10월': 'from-[#4ecdc4] to-[#6eddd6]',
  '11~12월': 'from-[#ffd93d] to-[#ffe36d]',
};

const periodTextColors: Record<string, string> = {
  '1~2월': 'text-[#ff6b6b]',
  '3~4월': 'text-[#4ecdc4]',
  '5~6월': 'text-[#ffd93d]',
  '7~8월': 'text-[#ff6b6b]',
  '9~10월': 'text-[#4ecdc4]',
  '11~12월': 'text-[#ffd93d]',
};

export default function CurriculumSection() {
  const [activeTab, setActiveTab] = useState('go1');

  const renderTable = (curriculum: CurriculumItem[], title: string, subtitle: string) => (
    <div className="relative">
      {/* Title Card */}
      <div className="bg-gradient-to-br from-[#1a2332] to-[#2a3f5f] rounded-2xl p-8 md:p-10 mb-10 text-center">
        <h3
          className="text-3xl md:text-4xl font-bold text-white mb-2"
          style={{ fontFamily: 'Noto Serif KR, serif' }}
        >
          {title} <span className="text-[#ffd93d]">과정</span>
        </h3>
        <p className="text-gray-300 text-base">{subtitle}</p>
      </div>

      {/* Table Layout */}
      <div className="bg-white rounded-2xl shadow-md overflow-hidden">
        {/* Desktop Table */}
        <div className="hidden md:block">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[#1a2332]">
                <th className="py-4 px-6 text-white text-base font-bold text-center w-[140px] border-r border-white/10">시기</th>
                <th className="py-4 px-6 text-white text-base font-bold text-center w-[160px] border-r border-white/10">구분</th>
                <th className="py-4 px-6 text-white text-base font-bold text-left">학습 내용</th>
              </tr>
            </thead>
            <tbody>
              {curriculum.map((item, index) => {
                const gradientClass = periodColors[item.period] || 'from-[#4ecdc4] to-[#6eddd6]';
                const isLast = index === curriculum.length - 1;
                return (
                  <tr
                    key={item.period}
                    className={`${!isLast ? 'border-b border-gray-100' : ''} hover:bg-gray-50/50 transition-colors duration-200`}
                  >
                    <td className="py-5 px-6 text-center border-r border-gray-100">
                      <span
                        className={`inline-block px-4 py-1.5 bg-gradient-to-r ${gradientClass} text-white text-sm font-bold rounded-full`}
                      >
                        {item.period}
                      </span>
                    </td>
                    <td className="py-5 px-6 text-center border-r border-gray-100">
                      {item.type ? (
                        <span className="inline-block px-4 py-1.5 bg-[#1a2332] text-white text-sm font-medium rounded-full whitespace-nowrap">
                          {item.type}
                        </span>
                      ) : (
                        <span className="text-gray-400 text-sm">—</span>
                      )}
                    </td>
                    <td className="py-5 px-6">
                      <ul className="space-y-1.5">
                        {item.details.map((detail, dIdx) => (
                          <li key={dIdx} className="flex items-start gap-2.5 text-gray-700 text-base leading-relaxed">
                            <span className={`mt-2 w-2 h-2 rounded-full bg-gradient-to-r ${gradientClass} flex-shrink-0`}></span>
                            {detail}
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden p-4 space-y-4">
          {curriculum.map((item) => {
            const gradientClass = periodColors[item.period] || 'from-[#4ecdc4] to-[#6eddd6]';
            return (
              <div key={item.period} className="bg-gray-50 rounded-xl p-5 border border-gray-100">
                <div className="flex items-center gap-3 mb-3">
                  <span
                    className={`inline-block px-4 py-1.5 bg-gradient-to-r ${gradientClass} text-white text-[13px] font-bold rounded-full`}
                  >
                    {item.period}
                  </span>
                  {item.type && (
                    <span className="inline-block px-3 py-1 bg-[#1a2332] text-white text-[12px] font-medium rounded-full">
                      {item.type}
                    </span>
                  )}
                </div>
                <ul className="space-y-2">
                  {item.details.map((detail, dIdx) => (
                    <li key={dIdx} className="flex items-start gap-2 text-gray-700 text-[14px] leading-[1.7]">
                      <span className={`mt-1.5 w-1.5 h-1.5 rounded-full bg-gradient-to-r ${gradientClass} flex-shrink-0`}></span>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );

  return (
    <section id="curriculum" className="py-14 md:py-24 bg-[#f7f7f5]">
      <div className="max-w-6xl mx-auto px-5 md:px-12">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-[13px] md:text-base text-[#ff6b6b] font-medium mb-4 tracking-wider">
            Curriculum
          </p>
          <h2
            className="text-[1.6rem] md:text-5xl font-bold text-[#1a2332] mb-4"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            연간 <span className="text-[#4ecdc4]">커리큘럼</span>
          </h2>
          <p className="text-gray-500 text-[14px] md:text-lg leading-relaxed">
            체계적인 연간 학습 로드맵으로 목표 달성을 이끕니다
          </p>
        </div>

        {/* Tab Selector */}
        <div className="flex justify-center mb-10 md:mb-14">
          <div className="bg-white rounded-full p-1 shadow-md inline-flex">
            <button
              onClick={() => setActiveTab('go1')}
              className={`px-5 py-2.5 md:px-6 md:py-3 rounded-full text-[14px] md:text-base font-bold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeTab === 'go1'
                  ? 'bg-[#1a2332] text-white'
                  : 'text-gray-500 hover:text-[#1a2332]'
              }`}
            >
              고1 국어
            </button>
            <button
              onClick={() => setActiveTab('go2')}
              className={`px-5 py-2.5 md:px-6 md:py-3 rounded-full text-[14px] md:text-base font-bold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeTab === 'go2'
                  ? 'bg-[#1a2332] text-white'
                  : 'text-gray-500 hover:text-[#1a2332]'
              }`}
            >
              고2 국어
            </button>
            <button
              onClick={() => setActiveTab('go3')}
              className={`px-5 py-2.5 md:px-6 md:py-3 rounded-full text-[14px] md:text-base font-bold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeTab === 'go3'
                  ? 'bg-[#1a2332] text-white'
                  : 'text-gray-500 hover:text-[#1a2332]'
              }`}
            >
              수능 정시반
            </button>
          </div>
        </div>

        {activeTab === 'go1' && renderTable(go1Curriculum, '고1', '열린학원 \u00B7 후니국담 국어')}
        {activeTab === 'go2' && renderTable(go2Curriculum, '고2', '열린학원 \u00B7 후니국담 국어')}
        {activeTab === 'go3' && renderTable(go3Curriculum as CurriculumItem[], '고3', '열린학원 \u00B7 수능 정시반')}
      </div>
    </section>
  );
}
